import { showSuccess, showError } from "utils/notifications";
import { showConfirmBox } from 'utils/ConfirmHelper';
import { useRoleVerify } from "Common/RoleVerify";

const DeleteBtn = ({ id, fetchData, apiDeleteFunction, itemName = "item", disabled = false }) => {
  const CanDelete = useRoleVerify("", ["can_delete"]);
  const deleteHandler = async () => {
    try {
      if (!CanDelete) return;
      if (disabled) return;
      const confirmed = await showConfirmBox(`Are you sure you want to delete this ${itemName}?`);
      if (!confirmed) return;

      const response = await apiDeleteFunction({ id });

      if (response.data?.success || response.success) {
        showSuccess(response.data?.message || response.message || `${itemName} deleted successfully`);
        if (fetchData) fetchData();
      } else {
        showError(response.data?.error || response.error || `An error occurred while deleting the ${itemName}`);
      }
    } catch (error) {
      console.error(`Error deleting ${itemName}:`, error);
      showError(error.response?.data?.message || error.response?.message || `An error occurred while deleting the ${itemName}`);
    }
  };

  return (
    CanDelete && (
      <button
        type="button"
        className="btn btn-danger btn-sm border rounded-2"
        onClick={deleteHandler}
        aria-label={`Delete ${itemName}`}
        title={`Delete ${itemName}`}
        disabled={disabled}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width={20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" className="svg-stroke">
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M4 7l16 0" />
          <path d="M10 11l0 6" />
          <path d="M14 11l0 6" />
          <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
          <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
        </svg>
      </button>
    )
  );
};

export default DeleteBtn;
